import React from 'react';
import globalStyles from 'layouts/material-admin/globalStyles';
import styles from './styles/PageBaseStyles';
import Paper from 'material-ui/Paper';
import { Grid } from 'react-flexbox-grid';

import ContentBack from 'material-ui/svg-icons/navigation/arrow-back';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import DownloadButtons from 'containers/downloadButtons/DownloadButtons';
import {browserHistory} from 'react-router';

const PageBase = (props) => (
    <Grid fluid>
        {
            props.showGoToButtons ?
                <div style={styles.goToContainer} >
                    <FloatingActionButton mini={true} style={styles.goToButton} onClick={browserHistory.goBack} >
                        <ContentBack />
                    </FloatingActionButton>
                </div>
            : null
        }
        {
            props.showDownloadButtons ?
            <div style={styles.goToContainer} >
                <DownloadButtons id={props.id} isIcnPlus={props.isIcnPlus} isDent={props.isDent}  />
                <div style={globalStyles.clear} ></div>
            </div>
            : null
        }
        <span style={globalStyles.navigation}>
            {props.title}
        </span>

        <div style={globalStyles.clear} ></div>
        <Paper style={globalStyles.paper}>
            {props.children}
            <div style={globalStyles.clear}/>
        </Paper>
    </Grid>
);

export default PageBase;


// WEBPACK FOOTER //
// ./src/components/common/PageBase.js